<template>
  <div>
    <label class="block text-sm font-medium mb-1">{{ $t('enterBirthdate') }}</label>
    <div class="flex gap-2">
      <Select
        v-model="localMonth"
        :options="monthsOptions"
        option-label="name"
        option-value="value"
        :placeholder="$t('month')"
        class="w-28 mr-2"
        :filter="true"
        :clearable="true"
      />
      <Select
        v-model="localDay"
        :options="daysOptions"
        option-label="name"
        option-value="value"
        :placeholder="$t('day')"
        class="w-28 mr-2"
        :filter="true"
        :clearable="true"
      />
      <Select
        v-model="localYear"
        :options="yearsOptions"
        option-label="name"
        option-value="value"
        :placeholder="$t('year')"
        class="w-28"
        :filter="true"
        :clearable="true"
      />
    </div>
    <div
      v-if="birthdateError"
      class="text-red-600 text-xs mt-1"
    >
      {{ birthdateError }}
    </div>
  </div>
</template>

<script setup>
const { $i18n: i18n } = useNuxtApp()

const emit = defineEmits(['update:value', 'valid'])

const localYear = ref('')
const localMonth = ref('')
const localDay = ref('')

const birthdateError = ref('')

const props = defineProps({
  value: {
    type: Object,
    default: () => ({ year: '', month: '', day: '' })
  }
})

// Sync local values with prop on change
watch(
  () => props.value,
  (val) => {
    if (val) {
      localYear.value = val.year || ''
      localMonth.value = val.month || ''
      localDay.value = val.day || ''
    }
  },
  { immediate: true, deep: true }
)

const monthsOptions = computed(() => {
  const months = []
  for (let i = 0; i < 12; i++) {
    months.push({ name: i18n?.t('monthsYear.' + i), value: i + 1 })
  }
  return months
})
const currentDate = new Date()
const yearsOptions = computed(() => {
  return Array.from({length: currentDate.getFullYear()-1900+1}, (_, i) => {
    const year = currentDate.getFullYear()-i
    return { name: year.toString(), value: year }
  })
})
const daysOptions = computed(() => {
  // Always show 31 days if month or year is not selected
  if (!localMonth.value || !localYear.value) {
    return Array.from({length: 31}, (_, i) => ({ name: (i+1).toString(), value: i+1 }))
  }
  // Use month-1 for correct days in month
  const daysInMonth = new Date(localYear.value, localMonth.value, 0).getDate()
  return Array.from({length: daysInMonth}, (_, i) => ({ name: (i+1).toString(), value: i+1 }))
})

const is21OrOlder = computed(() => {
  if (!localYear.value || !localMonth.value || !localDay.value) return false
  const today = new Date()
  const birth = new Date(localYear.value, localMonth.value-1, localDay.value)
  let age = today.getFullYear() - birth.getFullYear()
  const m = today.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--
  }
  return age >= 21
})

watch([localYear, localMonth, localDay], () => {
  if (!localYear.value && !localMonth.value && !localDay.value) {
    birthdateError.value = i18n?.t('birthdateRequired')
    emit('valid', false)
  } else if (!is21OrOlder.value) {
    birthdateError.value = i18n?.t('mustBe21OrOlder')
    emit('valid', false)
  } else {
    birthdateError.value = ''
    emit('valid', true)
  }
  emit('update:value', { year: localYear.value, month: localMonth.value, day: localDay.value })
})
</script>
